export default "__VITE_ASSET__QZd49DsG__"